///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GtthKeyValueDTO, ProductRadioDTO, ProductTypeEnum, ProjectProductsDTO } from '../../generated/shared-types.model';
import { isDefined } from '@siklu/sui-lib/utils';

@Injectable()
export class ProductRadioService {
    private readonly resourceUrl = 'api/product-radios';

    constructor(private readonly http: HttpClient) {}

    create(productRadio: ProductRadioDTO): Observable<ProductRadioDTO> {
        return this.http.post<ProductRadioDTO>(this.resourceUrl, productRadio).pipe(catchError(() => of({} as ProductRadioDTO)));
    }

    update(productRadio: ProductRadioDTO): Observable<ProductRadioDTO> {
        return this.http.put<ProductRadioDTO>(this.resourceUrl, productRadio).pipe(catchError(() => of({} as ProductRadioDTO)));
    }

    find(id: number): Observable<ProductRadioDTO> {
        return this.http.get<ProductRadioDTO>(`${this.resourceUrl}/${id}`).pipe(catchError(() => of(undefined)));
    }

    queryByType(type: ProductTypeEnum): Observable<ProductRadioDTO[]> {
        return this.http.get<ProductRadioDTO[]>(`${this.resourceUrl}/type/${type}`).pipe(catchError(() => of([])));
    }

    queryForProject(projectId: number): Observable<ProjectProductsDTO> {
        return this.http
            .get<ProjectProductsDTO>(`${this.resourceUrl}/project/${projectId}`)
            .pipe(catchError(() => of({} as ProjectProductsDTO)));
    }

    queryMh(projectId?: number, customerId?: number): Observable<ProductRadioDTO[]> {
        let params = new HttpParams();
        if (isDefined(projectId)) {
            params = params.set('projectId', projectId);
        }
        if (isDefined(customerId)) {
            params = params.set('customerId', customerId);
        }
        return this.http
            .get<ProductRadioDTO[]>(`${this.resourceUrl}/project/mh`, {
                params
            })
            .pipe(catchError(() => of([])));
    }

    delete(id: number): Observable<number> {
        return this.http.delete<number>(`${this.resourceUrl}/${id}`);
    }

    changePriority(radioIdPriorityList: GtthKeyValueDTO[]): Observable<ProductRadioDTO[]> {
        return this.http.put<ProductRadioDTO[]>(`${this.resourceUrl}/priority`, radioIdPriorityList).pipe(catchError(() => of([])));
    }
}
